<!-- メニューヘッダー -->
<template>
  <div class="menu-header">
    <div class="left">
      <button class="button-back" @click="goToSheet">
        <img :src="require(`@/assets/img/icon/svg/button-back.svg`)" />
      </button>
    </div>

    <div class="center">
      <img
        :src="require(`@/assets/img/material/emot-passport-logo.png`)"
        alt=""
      />
    </div>

    <img
      :src="require(`@/assets/img/material/hakone-soba-logo.png`)"
      class="header-img"
      alt=""
    />
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "TheSheetMenuHeader",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const book = computed(() => store.getters["ticketing/book"]);
    const sheet = computed(() => store.getters["ticketing/sheet"]);

    const goToSheet = () => {
      router.push({
        name: "Sheet",
        params: {
          book_group_id: route.params.book_group_id,
          book_id: book.value.id,
          master_sheet_id: sheet.value.master_sheet_id,
          sheet_id: String(sheet.value.id),
        },
        query: { language: store.getters["common/lang"] },
      });
    };

    return {
      goToSheet,
    };
  },
};
</script>

<style lang="scss" scoped>
.menu-header {
  padding-bottom: 10px;
  -webkit-box-shadow: rgb(0 0 0 / 15%) 0px 3px 6px;
  box-shadow: rgb(0 0 0 / 15%) 0px 3px 6px;
  height: 170px;
  position: fixed;
  width: 100%;
  background: white;
  z-index: 1;
  .center {
    width: 35%;
    margin: auto;
    img {
      width: 100%;
      top: calc(15px + env(safe-area-inset-top, 30px) + 30px);
      position: relative;
      max-width: 130px;
    }
  }

  .header-img {
    width: 65%;
    margin: auto;
    display: block;
    margin-top: 60px;
    max-width: 245px;
  }
}
</style>
